import React from 'react'

export interface DateInputUpdate {
  id: string
  value: string
}

interface DateInputProps {
  action?: (t: DateInputUpdate) => void
  id: string
  value: string | undefined
  style?: object
  disabled?: boolean
}

export const DateInput = ({ action, id, value, style = {}, disabled = false }: DateInputProps) =>
  <input
    disabled={disabled}
    type='date'
    style={style}
    onChange={e => action && action({id, value: e.target.value})}
    value={value} />
